import { Card, CardContent, CardHeader } from "@/components/ui/card";
import type { PersonalHistoryStepResult } from "@/types/classification";
import { ChevronDown, ChevronRight } from "lucide-react";
import { useState } from "react";
import DebugInfoJsonViewer from "./DebugInfoJsonViewer";

interface PersonalHistoryStepResultCardProps {
  result: PersonalHistoryStepResult;
}

export function PersonalHistoryStepResultCard({ result }: PersonalHistoryStepResultCardProps) {
  const [expanded, setExpanded] = useState(false);

  return (
    <Card className="rounded-md border bg-muted/30">
      <CardHeader>
        <div className="flex items-center gap-2">
          <button
            className="flex items-center gap-2 w-full text-left focus:outline-none"
            onClick={() => setExpanded((prev) => !prev)}
            type="button"
          >
            {expanded ? <ChevronDown className="h-4 w-4 mr-2" /> : <ChevronRight className="h-4 w-4 mr-2" />}
            <span className="font-medium">Personal History Step Result</span>
          </button>
        </div>
      </CardHeader>
      {expanded && (
        <CardContent className="space-y-4">
          <div>
            <div className="font-semibold mb-1">Personal History Codes</div>
            <div className="flex flex-wrap gap-2">
              {result.personalHistoryCodes && result.personalHistoryCodes.length > 0 ? (
                result.personalHistoryCodes.map((code) => (
                  <span
                    key={code.code}
                    className="inline-block bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-100 rounded-full px-3 py-1 text-sm font-medium"
                    title={code.reason || ""}
                  >
                    {code.code} - {code.description}
                    {code.reason && <span className="ml-2 text-xs text-muted-foreground">({code.reason})</span>}
                  </span>
                ))
              ) : (
                <span className="text-muted-foreground">No personal history codes found</span>
              )}
            </div>
          </div>
          {result.debugInfo && (
            <div>
              <div className="font-medium">Debug Info</div>
              <DebugInfoJsonViewer debugInfo={result.debugInfo} />
            </div>
          )}
        </CardContent>
      )}
    </Card>
  );
}

export default PersonalHistoryStepResultCard;
